import { Component, ChangeDetectorRef, Input } from '@angular/core';
import { MainComponent } from '../../common/pages/main/main.component';
import { Contact } from '../../services/contact/contact.model';
import { SettingService } from '../../common/services/setting/setting.service';
import { ContactService } from '../../services/contact/contact.service';
import { SelectService } from '../../common/services/select/select.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BackurlService } from 'src/common/services/backurl/backurl.service';
import { MatDialog } from '@angular/material/dialog';
import { CallRequestService } from 'src/common/services/call-request/call-request.service';

@Component({
  selector: 'app-contact-tab',
  templateUrl: './contact-tab.component.html',
  styleUrls: ['./contact-tab.component.scss']
})
export class ContactTabComponent extends MainComponent {

  public item: Contact;
  public callRequested = false;
  private _options: any = {
    editStart: false,
    displayOnly: false,
    displayRef: false,
    editOnly: false,
    noCard: false,
    hideFullname: false,
    hideContactDetails: false,
    link: false,
    backLinkModel: 'contacts',
    backLinkKey: null,
  };

  // public edit: boolean = false;

  @Input() set options(opts: any) {
    this._options = { ...this._options, ...opts };
  }
  get options(): any {
    return this._options;
  }


  constructor(
    protected _cd: ChangeDetectorRef,
    public setting: SettingService,
    public db: ContactService,
    public select: SelectService,
    protected route: ActivatedRoute,
    protected router: Router,
    public backURL: BackurlService,
    public dialog: MatDialog,
    private callRequest: CallRequestService,
  ) {
    super(_cd, setting, db, select, route, router, backURL, dialog);
    this.item = new Contact(null, setting);

  }

  protected _itemOnInit() {
    if (!this.options.displayOnly && (this.options.editStart || this.options.editOnly)) {
      this.pageConfig.edit = true;
    } else {
      this.pageConfig.edit = false;
    }
  }

  protected _newItemOnInit() {
    if (!this.options.displayOnly && (this.options.editStart || this.options.editOnly)) {
      this.pageConfig.edit = true;
    } else {
      this.pageConfig.edit = false;
    }
  }

  // editItem(){
  //   this.edit = true;
  // }

  goItem() {
    if (this.options.link && this.options.backLinkModel && this.options.backLinkKey && this.item.values.$key) {
      this.backURL.addURL(`/${this.options.backLinkModel}/${this.options.backLinkKey}`);
      const originalShouldReuse = this.router.routeReuseStrategy.shouldReuseRoute;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.navigate(['/contacts', this.item.values.$key]).then(() => {
        // restore original strategy
        this.router.routeReuseStrategy.shouldReuseRoute = originalShouldReuse;
      });
    }
  }

  goCompany(companyKey: string) {
    if (companyKey) {
      this.backURL.addURL(`/contacts/${this.item.values.$key}`);
      this.router.navigate(['/companies', companyKey]);
    }
  }

  goBroker() {
    if (this.checkAccessContact() && this.item.values.synaps?.contactBrokerObj?.$key) {
      this.backURL.addURL(`/contacts/${this.item.values.$key}`);
      this.router.navigate(['/brokers', this.item.values.synaps.contactBrokerObj.$key]);
    }
  }

  getTelLink(tel: string): string {
    if (!tel) return '';
    const normalized = tel.replace(/[^\d+]/g, '');
    return normalized ? `tel:${normalized}` : '';
  }

  requestPhoneCall(phone: string): void {
    if (this.callRequested) {
      return;
    }
    this.callRequested = true;
    this.callRequest.createCallRequest(phone, this.item?.values?.fullname, window.location.pathname);
    setTimeout(() => {
      this.callRequested = false;
    }, 5000);
  }

}
